export const style = {
  cardContainer: {
    mb: "1.6rem",
    p: "1.2rem 0.8rem",
    borderRadius: "0.8rem",
    background: "var(--neutral-100)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: "0.5rem",
  },
  footer: {
    mt: "1.4rem",
  },
  footerText: {
    display: "flex",
    alignItems: "center",
    color: "var(--gray-500)",
    fontSize: "1.2rem",
    fontWeight: 400,
  },
  spacing: {
    my: "0.6rem", // Equivalent to margin-block: 0.6rem
  },
  hideShowBlock: {
    display: {
      xs: "none",
      md: "block",
    },
  },

  buttonContainer: {
    overflowX: "auto",
    whiteSpace: "nowrap",
    mt: "0.6rem",
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    width: "100%",
    "& > button": {
      width: "100%",
    },
  },
  prescriptionButton: {
    width: "100%",
    "& > button": {
      width: "100%",
    },
  },
  testPatientDetail: {
    display: "flex",
    alignItems: "center",
    gap: "0.6rem",
  },
  borderLine: {
    marginTop: "0.8rem",
    borderTop: "0.1rem solid var(--gray-20)",
  },
  headerIcon: {
    width: "5.6rem",
    height: "5.6rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "2.8rem",
    border: "0.2rem solid var(--orange-50-transparent)",
    background: "var(--peach-100)",
  },
  contactSupportButton: {
    display: { xs: "flex", md: "none" },
  },
  contactSupportOrChatButton: {
    display: { xs: "flex", md: "none" },
    alignItems: "center",
    justifyContent: "center",
    width: "5.6rem",
    height: "4.8rem",
    padding: "0.6rem 0rem",
    gap: "0.8rem",
    background: "var(--orange-500)",
    borderRadius: "1.8rem",
    cursor: "pointer",
  },
  clinicLocation: {
    display: { xs: "flex", md: "none" },
    alignItems: "center",
    gap: "0.8rem",
  },
  mapText: {
    color: "var(--orange-500)",
    fontSize: "1.2rem",
    fontWeight: 500,
    cursor: "pointer",
  },
  directionButton: {
    display: { xs: "none", md: "block" },
    width: "100%",
  },
  detail: {
    display: "flex",
    alignItems: "center",
    gap: "0.2rem",
    marginTop: "0.6rem",
    color: "var(--gray-500)",
    fontSize: "1.2rem",
    fontWeight: 400,
  },
};
